import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback, useContext } from 'react';
import { measurementsActions } from '../../../../store/slices/measurementsSlice/measurementsSlice';
import { MeasuremntsContext } from '../../Context/MeasuremntsContext';

export const useAdditionallyCard = (cardId) => {
    const dispatch = useDispatch();
    const { setAdditionallyDelete, showPopup, popupProps, hidePopup } =
        useContext(MeasuremntsContext);

    const additionallyList = useSelector(
        (state) => state.measurementsReducer.additionallyList.entities
    );
    const additionallyCard = additionallyList[cardId];

    const onCloseCard = useCallback(
        (id) => {
            showPopup({
                needCrossIcon: false,
                text: (
                    <>
                        {i18next.t('useAdditionallyCard.return.onCloseCard.text.part1')}
                        <br />
                        {i18next.t('useAdditionallyCard.return.onCloseCard.text.part2', {
                            name: additionallyCard.name,
                        })}
                    </>
                ),
                danger: i18next.t('useAdditionallyCard.return.onCloseCard.danger'),
                cancel: i18next.t('useAdditionallyCard.return.onCloseCard.cancel'),
                onSubmit: () => {
                    hidePopup();
                    setAdditionallyDelete((prev) => [...prev, id]);
                    dispatch(measurementsActions.removeAdditionally(id));
                },
                onCancel: () => hidePopup(),
            });
        },
        [showPopup, popupProps, hidePopup]
    );

    const onInput = useCallback(
        (name, value) => {
            const changes = { [name]: value };
            dispatch(measurementsActions.changeAdditionally({ id: cardId, changes }));
        },
        [additionallyCard]
    );
    return { onCloseCard, additionallyCard, onInput };
};
